$("#drawer-close").click(function () {
    $(".drawer-collapse").collapse('hide');
})

$('#top-drawer').on('show.bs.collapse', function () {
    $("html, body").animate({
        scrollTop: 0
    }, "slow");
})